import { _t } from '@bark/bark-core';
import { TrackingHeap } from '../../../bark-core';

export default function ResubmitBarkPage() {
	const tracking = new TrackingHeap();
	const additionalDetailsModal = $('#__additional-details-resubmit-bark');
	const hashedProjectId = additionalDetailsModal.data('hashed-project-id');
  const instantResubmit = $('.resubmit-barks.instant-resubmit').length > 0;
  const existingText = additionalDetailsModal.data('existing-text');
  const existingFiles = Object.values(additionalDetailsModal.data('existing-files'));
  const existingImages = Object.values(additionalDetailsModal.data('existing-images'));
  const tformElement = document.getElementsByName('nrfTrustedFormToken')[0] ?? null;
  const tformToken = tformElement ? tformElement.getAttribute('value') : null;

	const handleLogEvent = (eventName, additionalParameters = {}) => {
		tracking.trackEvent('Resubmit Bark', eventName, {
			project_id: hashedProjectId,
			...additionalParameters,
		});
	};

  const onSubmit = () => {
    Bark.showLoading();
    const payload = {
      tform_token: tformToken,
      id: hashedProjectId,
    };
    Bark.json({
      url: '/buyers/post-resubmit/',
      data: { payload: JSON.stringify(payload) },
    })
      .done(function (e) {
        if (e.result === 'OK') {
          document.location = e.url;
          return;
        }
        alert(e.result);
        Bark.hideLoading();
      })
      .fail(function () {
        alert(_t("buyer_resubmit-bark:failed-error"));
        Bark.hideLoading();
      });

    handleLogEvent('Bark Resubmitted');
  };

	handleLogEvent('Viewed Resubmit Bark');

	const showAdditionalDetailsModal = async () => {
		window.BuyerApp.launchModule(
			'additional-details',
			'__additional-details-resubmit-bark',
			{
				hashedProjectId,
				currentAdditionalDetails: {
					fileAttachments: existingFiles,
					imageAttachments: existingImages,
					text: existingText,
				},
				showHeadingSuccessMessage: false,
				onSubmit: onSubmit,
				logEvent: handleLogEvent,
			},
		);
	};

	if (!instantResubmit) {
		showAdditionalDetailsModal();
	} else {
    onSubmit();
  }
}
